/**
 * Created by piotr.pozniak@thebeaverhead.com on 05/08/2024
 *
 * Untitled UI restyle of the fill bar — logic (interval/ETA/overtime math)
 * is unchanged, only the markup moved off Bootstrap's .progress/.progress-bar
 * onto QueueJobsPage.module.scss. The fill width is genuinely dynamic,
 * per-render data (not decoration), so it stays inline — same exception
 * theme/untitled/ProgressMeter's own fill bar makes.
 */
import React, { useEffect, useMemo, useState } from "react";
import { syncDurationInSeconds } from "../../helpers/sync";
import { durationToString } from "../../tools";
import styles from "./QueueJobsPage.module.scss";

/**
 * @param {Object} job
 */
const QueueJobProgress = ({ job }) => {
  const isSyncing = job.fetched && !job.failed && !job.completed;
  const [lastUpdated, setLastUpdated] = useState(new Date());

  const durationInSeconds = useMemo(() => {
    return syncDurationInSeconds(job);
  }, [job, lastUpdated]);

  // calculate progress in percent
  const progress = Math.round(
    (durationInSeconds * 100) / (job.data.last_duration + 30)
  );

  useEffect(() => {
    if (isSyncing && progress <= 100) {
      const interval = setInterval(() => {
        setLastUpdated(new Date());
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [isSyncing, durationInSeconds, progress]);

  if (!isSyncing) {
    return null;
  }
  if (!durationInSeconds) {
    return null;
  }

  if (progress > 100) {
    return (
      <span className={styles.progressOvertime}>
        It takes longer than usual: {durationToString(job.data.last_duration)}
      </span>
    );
  }

  return (
    <div
      className={styles.progressTrack}
      role="progressbar"
      aria-valuenow={progress}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div className={styles.progressFill} style={{ width: `${progress}%` }} />
    </div>
  );
};

export default QueueJobProgress;
